import React from 'react';
import PropTypes from 'prop-types';

/**
 * Read-only label + value display (same pattern as PurchaseOrderItemSave Current Price).
 * layout="inline" → "Order No: WEB-1" on one line (order detail dialogs).
 */
export default function ReadOnlyField({label, value, children, layout = 'stacked', className = ''}) {
    const displayValue = value === null || value === undefined || value === ''
    || value === 'null' || value === 'undefined'
        ? '-'
        : value;

    const fieldClass = [
        'settings-page__readonly-field',
        layout === 'inline' ? 'settings-page__readonly-field--inline' : '',
        className,
    ].filter(Boolean).join(' ');

    if (layout === 'inline') {
        return (
            <div className={fieldClass}>
                <span className="settings-page__readonly-field-label">
                    <span className="settings-page__readonly-field-label-text">{label}</span>
                    <span className="settings-page__readonly-field-label-colon">:</span>
                </span>
                <span className="settings-page__readonly-field-value">
                    {children !== undefined ? children : displayValue}
                </span>
            </div>
        );
    }

    return (
        <div className={fieldClass}>
            <div className="settings-page__readonly-field-label">{label}</div>
            <div className="settings-page__readonly-field-value">
                {children !== undefined ? children : displayValue}
            </div>
        </div>
    );
}

ReadOnlyField.propTypes = {
    label: PropTypes.node.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    children: PropTypes.node,
    layout: PropTypes.oneOf(['stacked', 'inline']),
    className: PropTypes.string,
};
